module.exports = __webpack_public_path__ + "static/media/smallAliens.dcc3a45f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/atlas/smallAliens.png
// module id = 874
// module chunks = 0